import React from 'react';

import { DEFAULT_SORT_OPTION_VALUE } from '../FilterProvider';
import {
  DEFAULT_PAGE,
  DEFAULT_ROWS_PER_PAGE,
  DEFAULT_ROWS_PER_PAGE_OPTIONS,
} from '../PaginationProvider/PaginationContext';

import type { FilterStorageContextValue } from './types';

export const DEFAULT_FILTER_STORAGE_CONTEXT_VALUE: FilterStorageContextValue = {
  filterStorage: {},
  getFilterByKey: () => ({}),
  setFilterByKey: () => null,
  sortOptionStorage: {},
  getSortOptionByKey: () => DEFAULT_SORT_OPTION_VALUE,
  setSortOptionByKey: () => null,
  paginationStorage: {},
  getPaginationByKey: () => ({
    page: DEFAULT_PAGE,
    rowsPerPage: DEFAULT_ROWS_PER_PAGE,
    rowsPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS,
  }),
  setPaginationByKey: () => null,
  filter: {},
  setFilter: () => null,
  sortOption: DEFAULT_SORT_OPTION_VALUE,
  sortQueryVariable: DEFAULT_SORT_OPTION_VALUE,
  setSortOption: () => null,
  pagination: {
    page: DEFAULT_PAGE,
    rowsPerPage: DEFAULT_ROWS_PER_PAGE,
    rowsPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS,
    onModelChange: () => null,
    resetPage: () => null,
  },
  paginationQueryVariables: {
    skip: DEFAULT_PAGE,
    first: DEFAULT_ROWS_PER_PAGE,
  },
  getPaginationObjectByKey: () => ({
    page: DEFAULT_PAGE,
    rowsPerPage: DEFAULT_ROWS_PER_PAGE,
    rowsPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS,
    onModelChange: () => null,
    resetPage: () => null,
  }),
  getPaginationQueryVariablesByKey: () => ({
    skip: DEFAULT_PAGE,
    first: DEFAULT_ROWS_PER_PAGE,
  }),
  getQueryParamsByKey: () => ({ filter: {}, sort: null }),
  resetStorage: () => null,
};

export const FilterStorageContext = React.createContext<FilterStorageContextValue>(
  DEFAULT_FILTER_STORAGE_CONTEXT_VALUE,
);
